import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { TrackingHandler } from 'client/tracking/handler';
import { TrackingMap } from 'client/tracking/maps/consumer-reviews/write-review/write-review';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildVehiclePath, VehicleEntities, VehicleModel } from 'client/data/models/vehicle-v2';
import { ConsumerReviewsParams } from 'site-modules/shared/utils/consumer-reviews/params';
import { getUrlPathFromParams } from 'site-modules/shared/utils/core-breadcrumbs-builder';
import { CoreBreadcrumbs } from 'site-modules/shared/components/core-breadcrumbs/core-breadcrumbs';
import { UpdateReviewForm } from 'site-modules/write-review/components/update-review-form/update-review-form';

const PAGE_DISPLAY_NAME = 'Write a Review';
const URL_PATH = 'write-review';

function UpdateReviewUI({ vehicleParams, reviewId, vehicle = null, location }) {
  useEffect(() => {
    TrackingHandler.useMap(TrackingMap);
  }, []);

  if (!vehicle) {
    return (
      <main id="main-content" tabIndex={-1} className="update-review">
        <Container>Loading&hellip;</Container>
      </main>
    );
  }

  return (
    <main id="main-content" tabIndex={-1} className="update-review">
      <Container className="pb-1_5">
        <CoreBreadcrumbs
          className="ps-0"
          vehicle={vehicle}
          breadcrumbsParams={{
            params: vehicleParams,
            pageDisplayName: PAGE_DISPLAY_NAME,
            urlPath: getUrlPathFromParams(vehicleParams, URL_PATH),
          }}
        />
        <Row>
          <Col xs={12} lg={8}>
            <UpdateReviewForm vehicle={vehicle} location={location} reviewId={reviewId} />
          </Col>
        </Row>
      </Container>
    </main>
  );
}

UpdateReviewUI.propTypes = {
  vehicleParams: ConsumerReviewsParams.isRequired,
  reviewId: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  vehicle: VehicleEntities.MakeModelSubmodelYear,
};

const mapStateToProps = state => ({
  isMobile: state.mobile,
  location: get(state, 'pageContext.location', {}),
});

export const UpdateReview = connect(mapStateToProps)(
  connectToModel(UpdateReviewUI, {
    vehicle: bindToPath(({ vehicleParams }) => buildVehiclePath(vehicleParams), VehicleModel),
  })
);
